// extracted by mini-css-extract-plugin
export default {"btnPrimary":"PretestButton_btnPrimary__dZ5ky"};